// 3rd party
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import * as _ from 'lodash';

// Models
import { OrganizationModel } from '../../../models/organization.model';
import { StudyModel } from '../../../models/study.model';
import { SurveyModel } from '../../../models/survey.model';

// Services
import { AppConfig } from '../../../app.config';
import { StudyContainerPageService } from '../../study-container-page/study-container-page.service';
import { StudyImageRequestService } from '../../../services/study-image-request.service';

@Component({
    selector: 'study-page',
    templateUrl: './study-page.component.html',
    styleUrls: ['./study-page.component.scss']
})
export class StudyPageComponent {
    constructor(
        private appConfig: AppConfig,
        private router: Router,
        private studyContainerPageService: StudyContainerPageService,
        private studyImageRequestService: StudyImageRequestService) { }

    // UI
    ui = {
        errorOnLoad: false,
        pageLoaded: false,
        step: 2
    };


    //----------------------------------
    // Lifecycle Hooks
    //----------------------------------

    ngOnInit() {
    }


    //----------------------------------
    // Public Methods
    //----------------------------------

    continue(organizationsSelected) {
        let redirectUrl = `/${this.studyContainerPageService.studySlugParam}/survey-gizmo?`;
        redirectUrl += `url=${_.get(this.studyContainerPageService.surveyModel.get('provider_config'), 'url')}`;
        redirectUrl += this._compileOrganizationsQueryParam(organizationsSelected);
        redirectUrl += `&study_revision=${this.studyContainerPageService.revisionId}`;
        redirectUrl += this.studyContainerPageService.studyLanguage ? `&sglocale=${this.studyContainerPageService.studyLanguage}` : '';
        window.location.href = redirectUrl;
    }


    //----------------------------------
    // Private
    //----------------------------------

    private _compileOrganizationsQueryParam(organizationsSelected) {
        let paramString = '';

        organizationsSelected.forEach((orgObj, objIndex) => {
            paramString += `&organizations_${objIndex + 1}_id=${orgObj.organization.id}`;
            paramString += `&organizations_${objIndex + 1}_name=${orgObj.organization.get('friendly_name') ? orgObj.organization.get('friendly_name') : orgObj.organization.get('name')}`;
            paramString += `&organizations_${objIndex + 1}_role=${orgObj.respondentRole}`;

            // Add custom meta data that was appended from the participant model
            let meta = orgObj.organization.attributes.participant_meta;

            if(meta !== null && typeof meta === 'object' && Object.keys(meta).length > 0) {
                for (var key in meta) {
                    paramString += `&organizations_${objIndex + 1}_meta_${encodeURIComponent(key)}=${encodeURIComponent(meta[key])}`;
                }
            }
        });

        return paramString;
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/study-container-page/study-page/study-page.component.ts